var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpen = function SvgOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 3v18M9.5 10l-2 2 2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 21H8a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5h3M14 21h2a5 5 0 0 0 5-5V8a5 5 0 0 0-5-5h-2"
  }))));
};
export { SvgOpen as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiY2IxNjk4YjliMTJmZDk2MTA0MDQxNWYxMjIwZDdhY2Iuc3ZnIjs=";